import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Renderer2,
  SkipSelf
} from "@angular/core";
import { Subscription } from "rxjs";

const TA_TAG_ATTRIBUTE: string = "ta-tag";

@Directive({
  selector: "[taTag]",
  exportAs: "taTag"
})
export class TestTagDirective implements OnInit, OnDestroy {
  @Input()
  get taTag(): string {
    return this._taTag;
  }
  set taTag(value: string) {
    if (value == null) {
      value = "";
    }

    if (this._taTag === value) {
      return;
    }
    this._taTag = value;

    if (this.initted) {
      this.setTag();
    }
  }
  private _taTag: string = "";

  get tag(): string {
    return `${this.tagPrefix}${this.taTag}`;
  }
  tagChange: EventEmitter<string> = new EventEmitter<string>();

  private tagPrefix: string = "";

  constructor(
    private elementRef: ElementRef,
    private renderer2: Renderer2,
    @Optional() @SkipSelf() private parent?: TestTagDirective
  ) {}

  private initted: boolean = false;
  private parentTagSubscription?: Subscription;
  ngOnInit(): void {
    this.initted = true;

    if (this.parent != null) {
      this.parentTagSubscription = this.parent.tagChange.subscribe(
        (parentTag) => {
          this.tagPrefix = parentTag !== "" ? `${parentTag}.` : "";
          this.setTag();
        }
      );

      this.tagPrefix = this.parent.tag !== "" ? `${this.parent.tag}.` : "";
    }

    this.setTag();
  }

  ngOnDestroy(): void {
    if (this.parentTagSubscription != null) {
      this.parentTagSubscription.unsubscribe();
    }
  }

  protected setTag(): void {
    if (this.taTag != null && this.taTag !== "") {
      this.renderer2.setAttribute(
        this.elementRef.nativeElement,
        TA_TAG_ATTRIBUTE,
        this.tag
      );
      this.tagChange.emit(this.tag);
    } else {
      this.renderer2.removeAttribute(
        this.elementRef.nativeElement,
        TA_TAG_ATTRIBUTE
      );
      this.tagChange.emit("");
    }
  }
}
